import { isIOS } from 'shared/javascripts/util/detection'
import { hasUnpoly } from 'shared/javascripts/util/unpoly_compat'
import debounce from 'lodash-es/debounce'

function awaitScrollEnd(viewport: EventTarget, delay = 75): Promise<void> {
  return new Promise((resolve) => {
    function done(): void {
      viewport.removeEventListener('scroll', debouncedDone)
      resolve()
    }

    // We consider scrolling to have stopped after we haven't received
    // a `scroll` event for `delay` milliseconds.
    //
    // The default delay (75) assumes a minimum framerate of ~13 FPS
    // while scrolling.
    const debouncedDone = debounce(done, delay)
    viewport.addEventListener('scroll', debouncedDone)
    debouncedDone()
  })
}

export default function smoothReveal(
  target: string | Element,
  revealPadding?: number,
): Promise<void> {
  const behavior = isIOS() ? 'auto' : 'smooth'

  if (hasUnpoly()) {
    up.reveal(target, { top: true, behavior, revealPadding })
  } else {
    // `up.reveal` also accounts for Unpoly's fixed-layout obstructions, which is what `revealPadding` is
    // mostly for; the Inertia app has none, so a plain scroll is the whole job there.
    const element = typeof target === 'string' ? document.querySelector(target) : target
    element?.scrollIntoView({ behavior, block: 'start' })
  }

  return awaitScrollEnd(document)
}
